export default "__VITE_ASSET__BvUXyYoa__"